<template lang="pug">
  .password-form
    .message-box(:class="{ alert: error.message }")
      p {{ $t(error.message) }}

    .labelArea
      p.title 新しいパスワードを入力してください
      p.article 半角英数字・記号を使用した8以上文字の文字列でパスワードを設定してください。

    .password-from-box
      text-field-with-icon(
        name="password"
        placeholder="新しいパスワード"
        v-model="password"
        autocomplete="on"
        @input="onChange"
      )
      text-field-with-icon(
        name="password"
        placeholder="新しいパスワード(確認)"
        v-model="passwordConfirm"
        autocomplete="on"
        @input="onChange"
      )
</template>

<style lang="scss" scoped>
.password-form {
  .message-box {
    width: 100%;
    height: 40px;
    text-align: center;
    p {
      margin: 0;
      padding: 0;
      @extend %body-text;
      line-height: 40px;
    }
  }
  .alert {
    background: $color-alert;
  }
  .labelArea {
    margin-top: 22px;
    padding-left: 16px;
    padding-right: 16px;
  }
  .title {
    @extend %headline-detail-text;
  }
  .article {
    margin-top: 60px;
  }
  .password-from-box {
    margin-top: 48px;
  }
  .sign-text-field {
    margin-top: 16px;
  }
  .labeled-check-box {
    text-align: right;
    margin: 24px 24px 0 0;
  }
}
</style>

<script>
import TextFieldWithIcon from '@/components/molecules/TextFieldWithIcon'
import SubmittableForm from '@/components/mixins/SubmittableForm'

export default {
  components: {
    TextFieldWithIcon,
  },
  mixins: [SubmittableForm],
  data() {
    return {
      password: '',
      passwordConfirm: '',
    }
  },
  methods: {
    validate() {
      return (
        this.password.length > 7 &&
        this.passwordConfirm.length > 7 &&
        this.password === this.passwordConfirm &&
        !!this.password.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/)
      )
    },
  },
}
</script>
